import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const coapplicantIncomeSectionComponent = {
  amount: 'coapplicant-income-section.amount',
  editLink: 'coapplicant-income-section.edit-link',
  frequency: 'coapplicant-income-section.frequency',
  h3: 'coapplicant-income-section.h3',
  incomeType: 'coapplicant-income-section.income-type',
  root: 'coapplicant-income-section.root',
  status: 'coapplicant-income-section.status',
} as const satisfies ComponentLocatorMap;
